import { useCallback, useState } from "react";
import { isNullOrWhiteSpace, isString } from "Utils/String";

import { IEditFieldProps } from "../IEditFieldProps";
import { IUseEditValue } from "./IUseEditValue";

export function useEditValue<T>(props: IEditFieldProps): IUseEditValue<T> {
  const {
    fieldName, isRequired, item, onChange, translator
  } = props;
  const [value, setValue] = useState<T>(item?.[fieldName] as T);

  const onChangeValue = useCallback(
    (_, newValue: T): void => {
      setValue(newValue);
      onChange(fieldName, newValue);
    },
    [fieldName, onChange]
  );

  const isValueMissing = isString(value) ? isNullOrWhiteSpace(value) : value == null;

  let errorMessage = null;
  if (isRequired && isValueMissing) {
    errorMessage = translator.get(`generic.missingvalue`, `This value is missing or invalid.`);
  }

  return { errorMessage, value, onChange: onChangeValue };
}
